export default __webpack_public_path__ + "static/media/grupa-catelusilor.83a6083a.png";